module.exports = __webpack_public_path__ + "static/img/logo_wk.33f2906.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo_wk.png
// module id = 9/bH
// module chunks = 15